<admin-app-header></admin-app-header>
<app-prospecting-nav></app-prospecting-nav>

<div class="prospecting-table-page">
    <div class="toolbar">
        <div class="toolbar-left">
            <h1><i class="fa-solid fa-table"></i> Prospects</h1>
            <span class="count-badge">{{ filtered.length | number }} of {{ allProspects.length | number }}</span>
        </div>
        <div class="toolbar-filters">
            <input type="text" placeholder="Search name, domain, address..." [(ngModel)]="search" (ngModelChange)="applyFilters()" />
            <select [(ngModel)]="statusFilter" (ngModelChange)="applyFilters()">
                <option value="">All statuses</option>
                <option *ngFor="let s of statusOptions" [value]="s">{{ statusLabels[s] }}</option>
            </select>
            <select [(ngModel)]="assigneeFilter" (ngModelChange)="applyFilters()">
                <option value="">All assignees</option>
                <option *ngFor="let a of assignees" [value]="a.$key">{{ a.displayName }}</option>
            </select>
            <select [(ngModel)]="sourceFilter" (ngModelChange)="applyFilters()">
                <option value="">All sources</option>
                <option *ngFor="let s of sourceOptions" [value]="s">{{ sourceLabels[s] }}</option>
            </select>
            <select [(ngModel)]="areaFilter" (ngModelChange)="applyFilters()">
                <option value="">All areas</option>
                <option *ngFor="let a of areas" [value]="a.slug">{{ a.name }}</option>
            </select>
            <select [(ngModel)]="searchTermFilter" (ngModelChange)="applyFilters()">
                <option value="">All search terms</option>
                <option *ngFor="let t of searchTermOptions" [value]="t">{{ t }}</option>
            </select>
            <select [(ngModel)]="prospectTypeFilter" (ngModelChange)="applyFilters()">
                <option value="">All types</option>
                <option *ngFor="let t of prospectTypeOptions" [value]="t">{{ prospectTypeLabels[t] }}</option>
            </select>
            <select [(ngModel)]="enrichedFilter" (ngModelChange)="applyFilters()">
                <option value="">Enriched: any</option>
                <option value="yes">Enriched</option>
                <option value="no">Not enriched</option>
            </select>
            <select [(ngModel)]="sortBy" (ngModelChange)="applyFilters()">
                <option value="created">Sort: newest</option>
                <option value="name">Sort: name</option>
                <option value="distance">Sort: nearest parking</option>
            </select>
        </div>
    </div>

    <div class="loading-state" *ngIf="loading">
        <i class="fa-solid fa-spinner fa-spin"></i> Loading prospects...
    </div>

    <div class="empty-state" *ngIf="!loading && !allProspects.length">
        <i class="fa-solid fa-magnifying-glass-location"></i>
        <p>No prospects yet. Run a scrape from the Scraper tab to discover head offices.</p>
    </div>

    <div class="table-wrap" *ngIf="!loading && filtered.length">
        <table>
            <thead>
                <tr>
                    <th>Company</th>
                    <th>Area</th>
                    <th>Industry</th>
                    <th>Headcount</th>
                    <th>Nearest parking</th>
                    <th>Contacts</th>
                    <th>Status</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let p of filtered" (click)="openProspect(p)" class="clickable">
                    <td>
                        <div class="company-cell">
                            <img *ngIf="p.logoUrl" [src]="p.logoUrl" class="logo" (error)="p.logoUrl = ''" />
                            <div>
                                <div class="name">{{ p.name }}</div>
                                <div class="domain" *ngIf="p.domain">{{ p.domain }}</div>
                            </div>
                        </div>
                    </td>
                    <td>{{ areaName(p.area) }}</td>
                    <td>{{ p.industry || '-' }}</td>
                    <td>{{ p.headcount || '-' }}</td>
                    <td>{{ nearestLabel(p) }}</td>
                    <td>{{ p.contactCount || 0 }}</td>
                    <td><span class="status-pill" [attr.data-status]="p.status">{{ statusLabel(p) }}</span></td>
                    <td><i class="fa-solid fa-chevron-right"></i></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
